<template>
  <el-dialog
    :title="`选择商品（已选数量：${multipleSelection.length}）`"
    :visible.sync="visible"
    append-to-body
    width="60%"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-table
      ref="table"
      v-loading="loading"
      height="200px"
      border
      :data="multipleSelection">
      <el-table-column
        label="商品名称">
        <template slot-scope="{row}">
          {{ row.productName || row.skuName }}
        </template>
      </el-table-column>
      <el-table-column
        label="商品编号"
        width="160"
        :resizable="false">
        <template slot-scope="{row}">
          {{ row.productNumber || row.skuCode }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="80"
        :resizable="false">
        <template slot-scope="{row}">
          <el-button
            type="danger"
            size="mini"
            @click="deleteItem(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider>请从下方选择商品</el-divider>
    <el-form
      :inline="true"
      style="display:flex;justify-content: space-between;"
      @submit.native.prevent>
      <el-form-item>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="config.productName"
          placeholder="请输入商品名称"
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
      ref="table"
      v-loading="loading"
      height="460px"
      border
      :data="list"
      row-key="skuId"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        reserve-selection
        :selectable="selectable"
        width="55">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="productName">
      </el-table-column>
      <el-table-column
        label="商品编号"
        width="160"
        :resizable="false"
        prop="productNumber">
      </el-table-column>
      <el-table-column
        label="商品品种"
        width="120"
        :resizable="false"
        prop="categoryName">
      </el-table-column>
      <el-table-column
        label="商品系列"
        width="120"
        :resizable="false"
        prop="productLineName">
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>

</template>
<script>
export default {
  name: 'ProductSelectNewModal',
  components: {},
  props: {
    option: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: ''
        // productTypes: [1, 9]
      },
      list: [],
      total: 0,
      multipleSelection: [],
      rows: []
    }
  },
  computed: {
    unselectables() {
      return this.rows.filter(i => i.outNum && i.outNum > 0)
    }
  },
  methods: {
    deleteItem(row) {
      const item = this.list.find(i => i.skuId === row.skuId)
      if (item) {
        this.$refs.table.toggleRowSelection(item, false)
      } else {
        this.$refs.table.toggleRowSelection(row, false)
      }
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.reset()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    selectable(row) {
      // console.log(row)
      return this.unselectables.findIndex(i => i.skuId === row.skuId) === -1
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: {
          ...this.config,
          ...this.option
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => ({
            ...i,
            skuId: i.productId,
            skuCode: i.productNumber
          }))
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.rows = row
      this.toggleModal(true)
      this.$nextTick(() => {
        row.forEach(i => {
          this.$refs.table.toggleRowSelection(i, true)
        })
        this.fetchList()
      })
    },
    reset() {
      // this.init = true
      this.config.pageNum = 1
      this.list = []
      this.total = 0
      this.multipleSelection = []
      this.rows = []
      this.$refs.table && this.$refs.table.clearSelection()
    },
    handleSubmit() {
      this.$emit('update:list', this.multipleSelection)
      this.toggleModal(false)
    }
  }
}
</script>
<style lang="stylus" scoped></style>
